// Central theme for the Answer Arena — colors shared between 3D scene and HTML overlay.

export const TEAM = {
  left: {
    name: "Green Titans",
    color: "#2eff7b",
    dark: "#0a4d24",
    glow: "#39ff88",
    accent: "#baffd4",
  },
  right: {
    name: "Violet Vipers",
    color: "#b04dff",
    dark: "#3a1060",
    glow: "#c377ff",
    accent: "#e6c9ff",
  },
};

export const ARENA = {
  bg: "#050510",
  fog: "#0a0a1e",
  floor: "#101024",
  grid: "#2a2a55",
  gold: "#ffd54a",
  tile: "#1b2a6b",
  tileEdge: "#3b55d4",
  wrong: "#ff4d5e",
  dup: "#ff9d3c",
};

export const FONTS = {
  display: "/fonts/LuckiestGuy-Regular.ttf",
  tech: "/fonts/Bungee-Regular.ttf",
};

// Deterministic bright color per player id — replaces the old random-every-render colors.
export function playerColor(id = "") {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return `hsl(${h % 360}, 85%, 62%)`;
}

export function teamOf(key) {
  return TEAM[key] || TEAM.left;
}
